import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clickableRowProps from '../../helpers/a11y/clickableRowProps'

// Nodig omdat de kop van een groep op Synchronisaties binnen een ReadOnlyGuard
// staat: als <button> zette de <fieldset disabled> van die poort hem uit, en
// kon een lezer de groepen niet open- en dichtklappen — wat niets wijzigt. Als
// eigen component omdat de pagina (38 imports) niet los te toetsen is.

/**
 * @param {object} props
 * @param {string} props.groupKey - Sleutel van de groep; ook het id-achtervoegsel van de groepsinhoud
 * @param {React.ReactNode} props.label - Naam van de groep
 * @param {number} props.count - Aantal synchronisaties in de groep
 * @param {boolean} props.collapsed - Of de groep dichtgeklapt is
 * @param {(groupKey: string) => void} props.onToggle - Klapt de groep open of dicht
 */
const SyncGroupToggle = ({ groupKey, label, count, collapsed, onToggle }) => (
    <span
        className="group-toggle"
        aria-expanded={!collapsed}
        aria-controls={`group-${groupKey}`}
        {...clickableRowProps(() => onToggle(groupKey))}
    >
        {collapsed ? <KeyboardArrowRightIcon /> : <KeyboardArrowDownIcon />}
        <span className="group-title">
            {label} <span className="group-count">({count})</span>
        </span>
    </span>
)

export default SyncGroupToggle
